import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { PathwayProgramLevelColumn } from '../../models/types';
import { Company, CompanyEnum } from '../../models/company.model';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { PriceListPathwayProgram } from '../../models/pricelist-pathway-program .model';
import { PricePipe } from '@lx/shared/ui/pipes';
import { TableModule } from 'primeng/table';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-pathway-program-table',
  templateUrl: './pathway-program-table.component.html',
  styleUrls: ['./pathway-program-table.component.scss'],
  imports: [TableHeaderComponent, PricePipe, TableModule, LowerCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PathwayProgramTableComponent {
  pathwayPrograms = input<PriceListPathwayProgram[] | undefined>(undefined);
  currency = input<Currency | undefined>(undefined);
  company = input<Company>(CompanyEnum.KIL);

  protected readonly columnLabels = computed(() => {
    const levels: PathwayProgramLevelColumn[] = [];
    const levelKeys = new Set<string>();

    this.pathwayPrograms()?.forEach(({ prices }) => {
      prices?.forEach(({ level, duration }) => {
        if (level === undefined || duration === undefined) {
          return;
        }

        const priceKey = `${level}:${duration}`;

        if (!levelKeys.has(priceKey)) {
          levels.push({ level, duration, priceKey });
          levelKeys.add(priceKey);
        }
      });
    });

    levels.sort((a, b) => String(b.duration).localeCompare(String(a.duration), undefined, { numeric: true }));

    return {
      title: 'Language Level',
      levels,
    };
  });

  protected readonly dataSource = computed(() => {
    return (
      this.pathwayPrograms()?.map(({ name, prices }) => {
        const programPrices: Record<string, number> = {};

        prices?.forEach(({ level, duration, price }) => {
          if (level !== undefined && duration !== undefined && price !== undefined) {
            programPrices[`${level}:${duration}`] = price;
          }
        });

        return { name: name ?? '', prices: programPrices };
      }) ?? []
    );
  });
}
